var _rect, _rect2, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "#f8fafb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 360,
    height: 360,
    rx: 24,
    fill: "#f1f3f5",
    stroke: "#e9ecef",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200,188)",
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-52,0 L-52,44 L0,68 L52,44 L52,0 L0,24 Z",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52,0 L0,-24 L0,24 L-52,0 Z",
    fill: "#ced4da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,0 L0,-24 L0,24 L52,0 Z",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52,0 L0,-24 L52,0 L0,24 Z",
    fill: "none",
    stroke: "#868e96",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52,0 L-52,44 L0,68 L52,44 L52,0",
    fill: "none",
    stroke: "#868e96",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 24,
    x2: 0,
    y2: 68,
    stroke: "#868e96",
    strokeWidth: 1.5
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 268,
    textAnchor: "middle",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 13,
    fill: "#adb5bd",
    letterSpacing: 0.5,
    fontWeight: 500
  }, "\u0417\u0443\u0440\u0430\u0433 \u0431\u0430\u0439\u0445\u0433\u04AF\u0439")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPlaceholder);
export default __webpack_public_path__ + "static/media/product-placeholder.347fa7bfca2a006774ff57674d5a4779.svg";
export { ForwardRef as ReactComponent };